import { withUnAuthenGuard } from '@libs/hoc/withUnAuthenGuard'
import { AuthenticationLayout } from './AuthenticationLayout'
import { withAuthenticationLayout } from './withAuthenticationLayout'

const ConnectedAuthenticationLayout = withUnAuthenGuard(
  withAuthenticationLayout(AuthenticationLayout)
)

export { ConnectedAuthenticationLayout as AuthenticationLayout }
